import { useEffect, useState } from "react";
import { api, GBP, fmtDate } from "@/lib/api";
import { PageHeader } from "@/components/Layout";

function PayStatus({ s }) {
  const map = { PAID: "#34D399", DUE: "#D4AF37", OVERDUE: "#F59E0B", FAILED: "#F87171", INITIATED: "#8C867A" };
  return <span className="text-[0.65rem] uppercase tracking-wider px-2 py-0.5 rounded-sm" style={{ color: map[s] || "#8C867A", background: `${map[s] || "#8C867A"}18` }}>{s}</span>;
}

export default function Payments() {
  const [payments, setPayments] = useState([]);
  const [members, setMembers] = useState({});
  const [filter, setFilter] = useState("ALL");

  useEffect(() => {
    api.get("/payments").then((r) => setPayments(r.data)).catch(() => {});
    api.get("/members").then((r) => { const map = {}; r.data.forEach((m) => (map[m.id] = m.name)); setMembers(map); }).catch(() => {});
  }, []);

  const filtered = filter === "ALL" ? payments : payments.filter((p) => p.status === filter);
  const totals = payments.reduce((a, p) => { a[p.status] = (a[p.status] || 0) + p.amount; return a; }, {});

  return (
    <div>
      <PageHeader eyebrow="Membership Revenue" title="Payments" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5 rise">
        {[["PAID", "#34D399"], ["DUE", "#D4AF37"], ["OVERDUE", "#F59E0B"], ["FAILED", "#F87171"]].map(([s, c]) => (
          <div key={s} className="panel rounded-sm p-4">
            <div className="eyebrow mb-2">{s}</div>
            <div className="font-serif text-2xl" style={{ color: c }}>{GBP(totals[s] || 0)}</div>
          </div>
        ))}
      </div>

      <div className="flex gap-2 mb-4">
        {["ALL", "PAID", "DUE", "OVERDUE"].map((f) => (
          <button key={f} onClick={() => setFilter(f)} data-testid={`pay-filter-${f}`}
            className={`px-3 py-1.5 rounded-sm text-xs uppercase tracking-wider border transition-all ${filter === f ? "border-[#C5A059] bg-[#1A1A1E] text-[#F5F3EF]" : "hairline text-[#8C867A]"}`}>{f}</button>
        ))}
      </div>

      <div className="panel rounded-sm overflow-hidden">
        <div className="grid grid-cols-12 gap-3 px-4 py-3 border-b hairline eyebrow">
          <div className="col-span-4">Member</div><div className="col-span-3">Period</div><div className="col-span-2">Amount</div><div className="col-span-3 text-right">Status</div>
        </div>
        <div className="divide-y" style={{ borderColor: "#28282D" }}>
          {filtered.map((p) => (
            <div key={p.id} className="grid grid-cols-12 gap-3 px-4 py-3.5 text-sm items-center">
              <div className="col-span-4 text-[#E2DFD7] truncate">{members[p.member_id] || "—"}</div>
              <div className="col-span-3 text-[#8C867A]">{p.period}</div>
              <div className="col-span-2 font-mono text-[#E2DFD7]">{GBP(p.amount)}</div>
              <div className="col-span-3 flex justify-end"><PayStatus s={p.status} /></div>
            </div>
          ))}
          {filtered.length === 0 && <div className="px-4 py-10 text-center text-sm text-[#8C867A]">No payments.</div>}
        </div>
      </div>
      <div className="text-[0.65rem] text-[#8C867A] mt-3">Security deposit funds are recorded separately as liabilities and are not shown here as revenue.</div>
    </div>
  );
}
